import { useCallback } from 'react';

const adminAppUrl = process.env.ADMIN_APP_URL;

export function useNavigateToAdminFormTemplateEditor() {
  const goToFormTemplateEditor = useCallback((formTemplateId: string) => {
    window.location.href = `${adminAppUrl}/form-templates/${formTemplateId}`;
  }, []);

  return goToFormTemplateEditor;
}
